import { useState } from 'react';

function LogOp({ operator: initialOperator, id, onLogOpChange }) {
    const [localOperator, setLocalOperator] = useState(initialOperator);
    const operator = onLogOpChange ? initialOperator : localOperator;

    function toggleLogOp() {
        const newOp = operator === 'AND' ? 'OR' : 'AND';
        if (onLogOpChange) {
            onLogOpChange(newOp);
        } else {
            setLocalOperator(newOp);
        }
    }

    return (
        <span className={`logOp ${id}`} id={id} onClick={toggleLogOp}>{operator}</span>
    );
}

export default LogOp;